import { QUICK_SEARCH_QUERY } from '../../constants';
import * as Analytics from '../Services/Analytics.service';

export const analyticsMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === QUICK_SEARCH_QUERY && action.payload?.query) {
    Analytics.trackSearch(action.payload.query);
  }

  return result;
};
